import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.82 2.28998L5.01 15.11L2 22L8.89 18.99L21.71 6.17998C22.1 5.78998 22.1 5.15998 21.71 4.76998L19.24 2.29998C18.84 1.89998 18.21 1.89998 17.82 2.28998Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.01 15.11L8.89 18.99L2 22L5.01 15.11Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2298 8.65995L15.3398 4.76995L17.8098 2.29995C18.1998 1.90995 18.8298 1.90995 19.2198 2.29995L21.6898 4.76995C22.0798 5.15995 22.0798 5.78995 21.6898 6.17995L19.2298 8.65995Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPen;
